import axios from "axios";
import Cookies from "js-cookie";
import { handleUnauthorizedResponse } from "../utils/authTokens";

// Create a base Axios instance
const apiClient = axios.create({
  // baseURL: process.env.REACT_APP_API_URL, // Base URL from .env // change this later
  baseURL: process.env.REACT_APP_API_BUY_URL,
  headers: {
    "Content-Type": "application/json;charset=utf8",
    accept: "*/*",
  },
});

// Request Interceptor
apiClient.interceptors.request.use(
  (config) => {
    const accessToken = Cookies.get("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => handleUnauthorizedResponse(error, apiClient)
);

export default apiClient;
